enum WaybillNoCategory {
    /** 普通电子面单 */
    STANDARD = "STANDARD",

    /** 子母单中的母单号 */
    PARENT = "PARENT",

    /** 子母单中的子单号 */
    CHILD = "CHILD",
}

export default WaybillNoCategory;
